import { PROFILE_ERROR, PROFILE_SUCCESS, EDIT_PROFILE, RESET_PROFILE_FLAG, CHANGE_PASSWORD, CHANGE_PASSWORD_ERROR, CHANGE_PASSWORD_SUCCESS } from "./actionTypes"

export const editProfile = user => {
  return {
    type: EDIT_PROFILE,
    payload: { user },
  }
}

export const profileSuccess = msg => {
  return {
    type: PROFILE_SUCCESS,
    payload: msg,
  }
}

export const profileError = error => {
  return {
    type: PROFILE_ERROR,
    payload: error,
  }
}

export const resetProfileFlag = error => {
  return {
    type: RESET_PROFILE_FLAG,
  }
}

export const changePasswordAction = (data, history) => {
  return {
    type: CHANGE_PASSWORD,
    payload: { data, history },
  }
}

export const changePasswordSuccess = (data, history) => {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    payload: { data, history },
  }
}

export const chnagePasswordError = (data, history) => {
  return {
    type: CHANGE_PASSWORD_ERROR,
    payload: { data, history },
  }
}
